export default __webpack_public_path__ + "static/media/gia-table.65f84fa5.png";